import React, { useState } from "react";
import { adminMemoryService } from "../../services/admin-memory.service";
import { useToast } from "../../context/ToastContext";
import type { Memory } from "../../services/memory.service";
import "../../styles/clients.css";

interface Props {
    entry: Memory;
    onClose: () => void;
    onDeleted: () => void;
}

export default function DeleteAdminKnowledgeModal({ entry, onClose, onDeleted }: Props) {
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleDelete = async () => {
        setError("");
        setLoading(true);

        try {
            await adminMemoryService.delete(entry.id);
            showToast("Knowledge entry deleted successfully.");
            onDeleted();
        } catch (err: any) {
            setError(err.response?.data?.message || err.response?.data?.msg || "Failed to delete entry.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                <h2>Delete Knowledge Entry</h2>
                <p className="modal-subtitle">This action cannot be undone</p>

                {error && <div className="modal-error">{error}</div>}

                <div className="delete-warning">
                    Are you sure you want to delete this entry?
                    <br /><br />
                    <strong>{entry.question}</strong>
                </div>

                <div className="modal-actions">
                    <button type="button" className="btn-modal-cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn-modal-danger"
                        onClick={handleDelete}
                        disabled={loading}
                    >
                        {loading ? "Deleting..." : "Delete"}
                    </button>
                </div>
            </div>
        </div>
    );
}
